export const configProd = {
  apiKey: 'AIzaSyC8dd0rpah5vcBsjz1M5m4hm8DDink-tfw',
  authDomain: 'selmane-prod.firebaseapp.com',
  databaseURL: 'https://selmane-prod.firebaseio.com',
  projectId: 'selmane-prod',
  storageBucket: 'selmane-prod.appspot.com',
  messagingSenderId: '182579430065'
}

export const configDev = {
  apiKey: 'AIzaSyBeptSarvtELsNBBubCqBMardheFle2gNQ',
  authDomain: 'selmane-dev.firebaseapp.com',
  databaseURL: 'https://selmane-dev.firebaseio.com',
  projectId: 'selmane-dev',
  storageBucket: 'selmane-dev.appspot.com',
  messagingSenderId: '488256919028'
}



// WEBPACK FOOTER //
// ./src/firebase/config.js